import { render, staticRenderFns } from "./adviceAccordion.vue?vue&type=template&id=5ce7ed8c"
import script from "./adviceAccordion.vue?vue&type=script&lang=js"
export * from "./adviceAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports